import { DomainEvent } from 'src/app/core/domain/events/domain_event';

import { Diary } from '../../diary/diary';

export class DiaryEvent extends DomainEvent<Diary> {}

export class DiaryCreated extends DiaryEvent {}

export class DiaryUpdated extends DiaryEvent {}
